import { ByCianStatistics } from 'shared/landingSeller/components/ByCianStatistics';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';

export const ByCianStatisticsContainer: React.FC = () => {
  const { device, handleOpenModal } = useWithModalForm();

  return <ByCianStatistics onOpenModal={handleOpenModal} device={device} />;
};
